/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Button, Row, Table, Alert } from 'react-bootstrap';
import Drawer from 'react-modern-drawer';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { toast } from 'react-hot-toast';
import guessFormat from 'moment-guess';
import moment from 'moment';
import _ from 'lodash';
import axios from 'axios';
import { loaderActions } from '../../../../../features/Loader/LoaderSlice';
import API from '../../../../../Services/API';
import { sortLinesByErrors } from '../../../../../Helpers/sort';
import OrderLine from '../../../../../components/shared/OrderLine/Index';
import { validatePurchaseLine, isSeafreightShipped } from '../../../../../Helpers/line.validation';
import { CheckRequireApproval } from '../../../../../Helpers/requireApproval';
import {
  useCurrentCompanyFullName,
  useCurrentCompanyID
} from '../../../../../hooks/useCurrentCompany';
import { formatDate } from '../../../../../Helpers/date';
import { isPOEligibleToPost } from '../../../../../Helpers/postable';

function ImportWarehousePOs() {
  const dispatch = useDispatch();
  const inputEl = useRef(null);
  const companyId = useCurrentCompanyID();
  const companyFullName = useCurrentCompanyFullName();

  const [isOpen, setIsOpen] = useState(false);
  const [isErrorDrawerOpen, setIsErrorDrawerOpen] = useState(false);
  const [uploadedLines, setUploadedLines] = useState([]);
  const [uploadedOrders, setUploadedOrders] = useState([]);
  const [postableOrders, setPostableOrders] = useState([]);
  const [dynamicsSaveErrors, setDynamicsSaveErrors] = useState([]);
  const [dynamicsPostErrors, setDynamicsPostErrors] = useState([]);
  const [dynamicsMissingErrors, setDynamicsMissingErrors] = useState([]);
  const { isFeedBackLoopEnabled } = useSelector((state) => state.general);

  const importPOs = () => {
    const line1Text = `For Suppliers PO's`;
    const fieldsList = `<br />
    <ol start="1" class="text-left" style="color: red">
    <li>Warehouse Confirm Quantity</li>
    <li>Warehouse Arrival Date</li>
    <li>Quantity Damaged</li>
    </ol>`;
    Swal.fire({
      title: 'Mass Upload info',
      icon: 'info',
      html: `${line1Text}, Only following fields are updatable: <br />` + `${fieldsList} `,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="feather icon-thumbs-up"></i> Great!',
      confirmButtonAriaLabel: 'Thumbs up, great!',
      cancelButtonText: '<i class="feather icon-thumbs-down"></i>',
      cancelButtonAriaLabel: 'Thumbs down'
    }).then((result) => {
      if (result.isConfirmed) {
        inputEl.current.click();
      }
    });
  };

  function handleFileChange(e) {
    if (e.target.files) {
      PurchaseExcelToJSON(e.target.files[0], 'warehouse');
    }
    e.target.value = null;
  }

  function ExcelDateToJSDate(serial) {
    const utcDays = Math.floor(serial - 25569);
    const utcValue = utcDays * 86400;
    const dateInfo = new Date(utcValue * 1000);
    return `${dateInfo.getFullYear()}-${(dateInfo.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${dateInfo.getDate().toString().padStart(2, '0')}`;
  }

  function ExcelDateToEVPFormat(date) {
    if (date) {
      const currentFormat = guessFormat(date);
      return moment(date, currentFormat).format('YYYY-MM-DD');
    } else {
      return date;
    }
  }

  const PurchaseExcelToJSON = async (file, vendorType) => {
    const reader = new FileReader();
    reader.onload = function (e) {
      dispatch(loaderActions.show());
      const binaryString = e.target.result;
      // convert the binary string to a workbook
      const workbook = XLSX.read(binaryString, { type: 'binary' });
      // get the first sheet
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      // convert the sheet to JSON
      const rows = XLSX.utils.sheet_to_json(sheet);
      if (rows.length === 0) {
        toast.error(`No Purchase Orders matching for warehouses.`);
        dispatch(loaderActions.hide());
      } else {
        const lines = rows.map((line) => {
          if (typeof line['Warehouse Arrival Date (yyyy/mm/dd)'] === 'number') {
            line['Warehouse Arrival Date (yyyy/mm/dd)'] = ExcelDateToJSDate(
              line['Warehouse Arrival Date (yyyy/mm/dd)']
            );
          } else {
            line['Warehouse Arrival Date (yyyy/mm/dd)'] = ExcelDateToEVPFormat(
              line['Warehouse Arrival Date (yyyy/mm/dd)']
            );
          }
          return {
            documentNo: line['Order No'],
            lineNo: line['Line No'],
            itemNo: line['Item No'],
            description: line.Description,
            vndrShpmntNo: String(line['Vendor Shipment Number']),
            locationCode: line['Location Code'],
            quantity: Number(line.Quantity),
            vendorConfirmQty: Number(line['Vendor Confirm Quantity']),
            wareHouseQty: Number(line['Warehouse Confirm Quantity']),
            actualReceiptDate: line['Warehouse Arrival Date (yyyy/mm/dd)'],
            qtyDmged: Number(line['Quantity Damaged']),
            isValid: true,
            editedFields: [],
            validationErrors: [],
            validationWarnings: []
          };
        });
        setUploadedLines(lines);
        LoadOrdersData(lines, vendorType);
      }
    };

    reader.onerror = function (ex) {
      dispatch(loaderActions.hide());
      console.log(ex);
    };
    reader.readAsBinaryString(file);
  };

  async function LoadOrdersData(lines, vendorType) {
    const uniqueOrders = [...new Set(lines.map((line) => line.documentNo))];
    const EmmaVendorParams = {
      company_id: process.env.REACT_APP_COMP_EMM,
      $select: `docNo,status,vendorPortalStatus,vendorPortalStatusCaption`
    };

    const DunVendorParams = {
      company_id: process.env.REACT_APP_COMP_DUN,
      $select: `docNo,status,vendorPortalStatus,vendorPortalStatusCaption`
    };

    let ordersList = [];
    await API()
      .get('/purchase_order_header', { params: EmmaVendorParams })
      .then((respEmma) => {
        if (respEmma.data.value !== undefined) {
          ordersList = ordersList.concat(respEmma.data.value).filter((order) => {
            return order && uniqueOrders.includes(order.docNo);
          });
        }
      });
    await API()
      .get('/purchase_order_header', { params: DunVendorParams })
      .then((resDun) => {
        if (resDun.data.value !== undefined) {
          ordersList = ordersList.concat(resDun.data.value).filter((order) => {
            return order && uniqueOrders.includes(order.docNo);
          });
        }
      });
    setUploadedOrders(ordersList);

    return await LoadPurchaseLinesData(lines, vendorType);
  }

  async function FetchPurchaseLinesData(lines, VendorType) {
    const uniqueOrders = [...new Set(lines.map((line) => line.documentNo))];

    const baseSelectFields = [
      'documentNo',
      'lineNo',
      'quantity',
      'originalQuantity',
      'qtyReceived',
      'vendorConfirmQty',
      'expectedReceiptDate',
      'plannedReceiptDate',
      'expectedDeliveryDate',
      'expectedShippingDate',
      'actualShippingDate',
      'vendorPortalStatus',
      'vendorPortalStatusCaption',
      'overReceiptCode',
      'directUnitCost',
      'vpFreightType',
      'seaFreightConfirmedQty'
    ];

    const feedbackFields = ['feedbackDate', 'feedbackStatus', 'feedbackType', 'feedbackUser'];

    // Conditionally add feedback fields
    const selectFields = isFeedBackLoopEnabled
      ? [...baseSelectFields, ...feedbackFields]
      : baseSelectFields;

    const commonParams = {
      $select: selectFields.join(',')
    };

    const vendorParams = {
      Emma: { company_id: process.env.REACT_APP_COMP_EMM },
      Dun: { company_id: process.env.REACT_APP_COMP_DUN }
    };

    const fetchOrderLines = async (vendor) => {
      const params = { ...vendor, ...commonParams };
      const response = await API().get('/purchase_order_lines', { params });
      return response?.data?.value || [];
    };

    try {
      const [emmaLines, dunLines] = await Promise.all([
        fetchOrderLines(vendorParams.Emma),
        fetchOrderLines(vendorParams.Dun)
      ]);

      const res = [...emmaLines, ...dunLines].filter(
        (order) => order && uniqueOrders.includes(order.documentNo)
      );
      return res;
    } catch (error) {
      console.error('Error fetching purchase lines:', error);
      throw error;
    }
  }

  async function LoadPurchaseLinesData(lines, VendorType) {
    const res = await FetchPurchaseLinesData(lines);
    let updatedLines = [];
    lines.forEach((targetLine) => {
      const updateLine = res.find(
        (line) => line.documentNo === targetLine.documentNo && line.lineNo === targetLine.lineNo
      );
      if (updateLine) {
        let qtyMissing =
          updateLine.vendorConfirmQty - (updateLine.qtyReceived + targetLine.wareHouseQty);
        if (qtyMissing < 0) {
          qtyMissing = 0;
        }
        let quantity = {
          quantity: updateLine.quantity,
          vendorConfirmQty: updateLine.vendorConfirmQty,
          vpFreightType: updateLine.vpFreightType
        };
        if (updateLine.vpFreightType === 'SeaRailAir') {
          quantity = {
            ...quantity,
            seaFreightConfirmedQty: Number(targetLine.wareHouseQty)
          };
        } else {
          quantity = {
            ...quantity,
            whseConfirmQty: Number(targetLine.wareHouseQty)
          };
        }
        delete targetLine.wareHouseQty;
        if (isFeedBackLoopEnabled) {
          updatedLines.push({
            ...targetLine,
            ...quantity,
            id: `${targetLine.documentNo}_${targetLine.lineNo}`,
            qtyMissing,
            actualShippingDate: updateLine.actualShippingDate,
            vendorPortalStatus: updateLine.vendorPortalStatus,
            vendorPortalStatusCaption: updateLine.vendorPortalStatusCaption,
            quantity: updateLine.quantity,
            originalQuantity: updateLine.originalQuantity,
            qtyReceived: updateLine.qtyReceived,
            feedbackDate: updateLine.feedbackDate,
            feedbackStatus: updateLine.feedbackStatus,
            feedbackType: updateLine.feedbackType,
            feedbackUser: updateLine.feedbackUser,
            overReceiptCode: updateLine.overReceiptCode,
            directUnitCost: updateLine.directUnitCost,
            plannedReceiptDate: updateLine.plannedReceiptDate
          });
        } else {
          updatedLines.push({
            ...targetLine,
            ...quantity,
            id: `${targetLine.documentNo}_${targetLine.lineNo}`,
            qtyMissing,
            actualShippingDate: updateLine.actualShippingDate,
            vendorPortalStatus: updateLine.vendorPortalStatus,
            vendorPortalStatusCaption: updateLine.vendorPortalStatusCaption,
            quantity: updateLine.quantity,
            originalQuantity: updateLine.originalQuantity,
            qtyReceived: updateLine.qtyReceived,
            overReceiptCode: updateLine.overReceiptCode,
            directUnitCost: updateLine.directUnitCost,
            plannedReceiptDate: updateLine.plannedReceiptDate
          });
        }
      } else {
        setDynamicsMissingErrors((prev) => {
          const errorsList = [
            ...prev,
            {
              documentNo: targetLine.documentNo,
              lineNo: targetLine.lineNo,
              id: `${targetLine.documentNo}_${targetLine.lineNo}`
            }
          ];
          return _.uniqBy(errorsList, 'id');
        });
      }
    });
    updatedLines = _.uniqBy(updatedLines, 'id');
    setUploadedLines(sortLinesByErrors(updatedLines));
    toggleDrawer();
  }

  const toggleDrawer = () => {
    if (isOpen) {
      setUploadedLines([]);
      setUploadedOrders([]);
      setPostableOrders([]);
    }
    setIsOpen((prevState) => !prevState);
    setTimeout(() => {
      dispatch(loaderActions.hide());
    }, 1000);
  };

  const toggleErrorDrawer = () => {
    if (isErrorDrawerOpen) {
      setDynamicsSaveErrors([]);
      setDynamicsMissingErrors([]);
    }
    setIsErrorDrawerOpen((prevState) => !prevState);
  };

  function editValue(documentNo, lineNo, targetField) {
    const targetKey = Object.keys(targetField)[0];
    setUploadedLines((prevState) => {
      return prevState.map((line) => {
        if (line.documentNo === documentNo && lineNo === line.lineNo) {
          line[targetKey] = targetField[targetKey];
        }
        return line;
      });
    });

    if (
      (targetKey === 'whseConfirmQty' && targetField[targetKey] > 0) ||
      (targetKey === 'seaFreightConfirmedQty' && targetField[targetKey] > 0)
    ) {
      setUploadedLines((prevState) => {
        return prevState.map((line) => {
          if (line.documentNo === documentNo && lineNo === line.lineNo) {
            let qtyMissing = line.vendorConfirmQty - (line.qtyReceived + targetField[targetKey]);
            if (qtyMissing < 0) {
              qtyMissing = 0;
            }
            line.qtyMissing = qtyMissing;
          }
          return line;
        });
      });
    }

    if (targetKey === 'qtyToReceive' && targetField[targetKey] > 0) {
      setUploadedLines((prevState) => {
        return prevState.map((line) => {
          if (line.documentNo === documentNo && lineNo === line.lineNo) {
            let qtyMissing = line.itemQty - (line.qtyShipped + targetField[targetKey]);
            if (qtyMissing < 0) {
              qtyMissing = 0;
            }
            line.qtyMissing = qtyMissing;
          }
          return line;
        });
      });
    }
  }

  async function validateLines(actionType) {
    let validatedLines = [];
    validatedLines = uploadedLines.map((line) => {
      const currentOrderLines = uploadedLines.filter(
        (targetLine) => targetLine.documentNo === line.documentNo
      );
      return validatePurchaseLine(line, 'warehouse', currentOrderLines, isFeedBackLoopEnabled);
    });
    setUploadedLines(sortLinesByErrors(validatedLines));
    if (validatedLines.filter((line) => !line.isValid).length === 0) {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Please make sure everything is uploaded properly, You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: `Yes, ${actionType} it!`
      });
      if (result.isConfirmed) {
        if (actionType.toLowerCase() === 'save') {
          savePurchaseLine();
        } else {
          savePurchaseLine(true);
        }
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please fix all lines invalid inputs...'
      });
    }
  }

  async function savePurchaseLine(alsoPost = false) {
    dispatch(loaderActions.show());
    const batchRequestData = saveableLines.map((line) => {
      let data = {
        actualReceiptDate: line.actualReceiptDate,
        qtyDmged: Number(line.qtyDmged),
        qtyMissing: Number(line.qtyMissing),
        SkipPriceValidation: Boolean(line.SkipPriceValidation)
      };

      if (line.vpFreightType === 'SeaRailAir') {
        data = {
          ...data,
          seaFreightConfirmedQty: Number(line.seaFreightConfirmedQty)
        };
      } else {
        data = {
          ...data,
          whseConfirmQty: Number(line.whseConfirmQty)
        };
      }
      return {
        method: 'PATCH',
        url: `purchaseOrderLinesVP('${line.documentNo}',${line.lineNo},'${line.itemNo}')`,
        headers: {
          Company: companyFullName,
          'Content-Type': 'application/json',
          'If-Match': '*'
        },
        body: data
      };
    });
    if (batchRequestData.length > 0) {
      const subOrderRequestCalls = Math.ceil(batchRequestData.length / 50);
      const batchRequestSubData = [];
      for (let i = 0; i < subOrderRequestCalls; i++) {
        const subOrderRequestData = batchRequestData.slice(i * 50, (i + 1) * 50);
        batchRequestSubData.push(subOrderRequestData);
      }
      const responses = [];
      const errors = [];
      const promises = [];
      batchRequestSubData.forEach((RequestSubData) => {
        promises.push(
          API()
            .post('/purchase-batch', { requests: RequestSubData })
            .then((resp) => responses.push(resp))
            .catch((err) => errors.push(err))
        );
      });
      Promise.all(promises)
        .then(() => {
          const dynamicsErrorsList = [];
          responses.forEach((resp) => {
            resp.data.responses.forEach((POLineResponse) => {
              if (POLineResponse.status !== 200) {
                dynamicsErrorsList.push(POLineResponse.body.error);
              }
            });
          });
          setDynamicsSaveErrors(dynamicsErrorsList);
          if (alsoPost === false) {
            if (dynamicsSaveErrors.length > 0 || dynamicsMissingErrors.length > 0) {
              toggleDrawer();
              toggleErrorDrawer();
              dispatch(loaderActions.hide());
            } else {
              toggleDrawer();
              dispatch(loaderActions.hide());
              toast.success('Order lines saved successfully');
            }
          }
        })
        .catch(() => {
          console.log(errors);
        });
    }
    if (alsoPost === true) {
      const multiplePostDocs = postableOrders.map((order) => {
        return `/warehouse_post?(${companyId})?('${order}')`;
      });
      const res = await axios.all(
        multiplePostDocs.map((url) =>
          API().post(url, {
            postDate: formatDate(new Date())
          })
        )
      );

      const errors = [];
      res.forEach((err) => {
        if (err.response && typeof err.response === 'object' && err.response.data) {
          errors.push({
            po: err.config.url.split('?')[2].split(`'`)[1],
            message: err.response.data.message
          });
        }
      });
      const postErrors = [...new Set(errors)];
      setDynamicsPostErrors(postErrors);
      if (
        dynamicsPostErrors.length > 0 ||
        dynamicsSaveErrors.length > 0 ||
        postErrors.length > 0 ||
        dynamicsMissingErrors.length > 0
      ) {
        toggleDrawer();
        toggleErrorDrawer();
        dispatch(loaderActions.hide());
      } else {
        toggleDrawer();
        dispatch(loaderActions.hide());
        toast.success('Order lines posted successfully');
      }
    }
  }

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.removeProperty('overflow');
    }
  }, [isOpen]);

  const uploadedRows = uploadedLines.map((line, index) => {
    if (!line.vendorPortalStatusCaption || line.vendorPortalStatusCaption.trim() === '') {
      const targetOrder = uploadedOrders.find((order) => order.docNo === line.documentNo);
      if (targetOrder) {
        line.vendorPortalStatusCaption = targetOrder.vendorPortalStatusCaption;
      } else {
        line.vendorPortalStatusCaption = 'Confirmation Sent to Vendor';
      }
    }
    const currentOrderLines = uploadedLines.filter(
      (targetLine) => targetLine.documentNo === line.documentNo
    );
    return (
      <OrderLine
        documentNo={line.documentNo}
        line={line}
        index={index}
        vendorType={'warehouse'}
        key={index}
        type={'purchase'}
        editValue={editValue}
        showSaveButton={false}
        showOrderLink={true}
        directLink={'/purchase-order'}
        orderLines={currentOrderLines}
      />
    );
  });

  useEffect(() => {
    let linesByPo = _.groupBy(uploadedLines, 'documentNo');
    uploadedLines.forEach((line) => {
      if (line.vpFreightType === 'SeaRailAir') {
        linesByPo = _.omit(linesByPo, line.documentNo);
      }
    });
    const postablePos = [];
    for (const key in linesByPo) {
      const notPostableLine = _.filter(linesByPo[key], (line) => {
        return CheckRequireApproval(line, isFeedBackLoopEnabled) === true;
      });
      if (notPostableLine.length === 0) {
        const targetPo = uploadedOrders.find((po) => po.docNo === key);
        if (targetPo && isPOEligibleToPost('warehouse', targetPo, linesByPo[key], [], [])) {
          postablePos.push(key);
        }
      }
    }
    setPostableOrders(postablePos);
  }, [uploadedLines]);

  const saveableLines = (
    isFeedBackLoopEnabled
      ? uploadedLines.filter((line) => line.feedbackStatus !== 'Pending')
      : uploadedLines
  ).filter((line) => !isSeafreightShipped(line));

  return (
    <>
      <Card className="p-4 ">
        <div className="text-center"></div>
        <Card.Body className="p-4">
          <Card.Title>
            <i className="feather icon-upload mt-2" /> &nbsp; Import Warehouse PO's
          </Card.Title>
          <Card.Text>
            Please verify Purchase Order (PO) lines before importing. Accuracy matters!, Only
            following fields will be updated if PO exists: <br />
            <li>Warehouse Confirm Quantity</li>
            <li>Warehouse Arrival Date</li>
            <li>Quantity Damaged</li>
          </Card.Text>
          <Button variant="primary" onClick={importPOs}>
            Import Warehouse PO's
          </Button>
        </Card.Body>
      </Card>

      <Drawer
        open={isOpen}
        onClose={() => {
          toggleDrawer();
        }}
        direction="right"
        size={'80vw'}
        style={{
          zIndex: '10000',
          overflowX: 'hidden',
          overflowY: 'scroll',
          paddingBottom: '10vh'
        }}
      >
        <div className="p-3">
          <div className="row">
            <div className="col align-self-start">Review Upload</div>
            <div className="col align-self-end text-right" role={'button'}>
              <i
                className="feather icon-x-circle ml-2 mt-2"
                style={{ fontSize: '150%', color: 'red' }}
                onClick={() => {
                  toggleDrawer();
                }}
              />
            </div>
          </div>
          {uploadedLines.length > 0 && (
            <Row className="mt-2 px-2" style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <Button variant="info" onClick={() => validateLines('Save')}>
                Save Lines ({saveableLines.length}/{uploadedLines.length})
              </Button>
              {postableOrders.length > 0 ? (
                <Button variant="primary" className="ml-2" onClick={() => validateLines('Post')}>
                  Post POs ({postableOrders.length}/{uploadedOrders.length})
                </Button>
              ) : (
                <></>
              )}
            </Row>
          )}
        </div>
        {uploadedLines.length > 0 && <div className="row mt-2 px-4">{uploadedRows}</div>}
        {uploadedLines.length > 0 && (
          <Row className="mt-4 px-4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="info" onClick={() => validateLines('Save')}>
              Save Lines ({saveableLines.length}/{uploadedLines.length})
            </Button>
            {postableOrders.length > 0 ? (
              <Button variant="primary" className="ml-2" onClick={() => validateLines('Post')}>
                Post POs ({postableOrders.length}/{uploadedOrders.length})
              </Button>
            ) : (
              <></>
            )}
          </Row>
        )}
        {uploadedLines.length === 0 && (
          <Row className="mt-4 px-4">
            <Alert variant={'warning'} className="mt-2" style={{ width: '100%' }}>
              <p>The uploaded POs are either posted or contain invalid data. Please review.</p>
            </Alert>
          </Row>
        )}
      </Drawer>

      <Drawer
        open={isErrorDrawerOpen}
        onClose={toggleErrorDrawer}
        direction="right"
        size={'80vw'}
        style={{
          zIndex: '10000',
          overflowX: 'hidden',
          overflowY: 'scroll',
          paddingBottom: '10vh'
        }}
      >
        <div className="p-3">
          <div className="row">
            <div className="col align-self-start">
              <h6>Response Errors</h6>
            </div>
            <div className="col align-self-end text-right" role={'button'}>
              <i
                className="feather icon-x-circle ml-2 mt-2"
                style={{ fontSize: '150%', color: 'red' }}
                onClick={() => {
                  if (isOpen) {
                    toggleDrawer();
                  }
                  toggleErrorDrawer();
                }}
              />
            </div>
          </div>
        </div>
        {dynamicsSaveErrors.length > 0 && (
          <>
            <div className="px-3">
              <div className="row">
                <div className="col align-self-start">
                  <u>Following Errors are recorded while Saving PO's</u>
                </div>
              </div>
            </div>
            <div className="row mt-2 px-4">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Code</th>
                    <th>Message</th>
                  </tr>
                </thead>
                <tbody>
                  {dynamicsSaveErrors.map((err, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{err.code}</td>
                        <td>{err.message}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </>
        )}
        {dynamicsMissingErrors.length > 0 && (
          <>
            <div className="px-3">
              <div className="row">
                <div className="col align-self-start">
                  <u>
                    The following PO lines are either missing from the Dynamics or have already been
                    posted.
                  </u>
                </div>
              </div>
            </div>
            <div className="row mt-2 px-4">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>PO #</th>
                    <th>Line #</th>
                  </tr>
                </thead>
                <tbody>
                  {dynamicsMissingErrors.map((err, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{err.documentNo}</td>
                        <td>{err.lineNo}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </>
        )}

        {dynamicsPostErrors.length > 0 && (
          <>
            <div className="px-3">
              <div className="row">
                <div className="col align-self-start">
                  <u>Following Errors are recorded while Posting PO's</u>
                </div>
              </div>
            </div>
            <div className="row mt-2 px-4">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>PO</th>
                    <th>Message</th>
                  </tr>
                </thead>
                <tbody>
                  {dynamicsPostErrors.map((err, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{err.po}</td>
                        <td colSpan={2}>{err.message}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </>
        )}
      </Drawer>

      <input
        type="file"
        ref={inputEl}
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.csv"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </>
  );
}

export default ImportWarehousePOs;
